import { consoleLogger } from '@shared/logging/consoleLogger';

export const triggerUtiqSecureSignalProvider = (atid: string | undefined) => {
  const isSecureSignalsDisabled = Boolean(
    window?.Utiq?.config?.integrations?.disableGoogleSecureSignals,
  );
  const isGoogleTagLoaded = Boolean(window.googletag);
  if (!isSecureSignalsDisabled && isGoogleTagLoaded && atid) {
    consoleLogger.logDebug(
      `triggering googletag.secureSignalProviders.push() code passing the adtechpass ${atid}`,
    );
    window.googletag!.secureSignalProviders ||= [];
    window.googletag!.secureSignalProviders.push({
      id: 'utiq.com',
      collectorFunction: () =>
        new Promise((resolver) => {
          // signal
          resolver(atid);
        }),
    });
  } else {
    consoleLogger.logDebug(
      `googletag.secureSignalProviders.push() not triggered, with isSecureSignalsDisabled: ${isSecureSignalsDisabled} and isGoogleTagLoaded: ${isGoogleTagLoaded}`,
    );
  }
};
